"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StepLayout = void 0;
const react_1 = __importStar(require("react"));
const core_1 = require("@material-ui/core");
const styles_1 = require("@material-ui/core/styles");
const react_custom_scrollbars_1 = __importDefault(require("react-custom-scrollbars"));
const react_div_100vh_1 = require("react-div-100vh");
const NavigationHeader_1 = __importDefault(require("../NavigationHeader/NavigationHeader"));
const ProgressBar_1 = __importDefault(require("../ProgressBar/ProgressBar"));
const ProgressTab_1 = require("../ProgressTab/ProgressTab");
const helpers_1 = require("../../helpers");
const useStyles = styles_1.makeStyles(theme => ({
    root: {
        ...helpers_1.responsiveWidth(theme),
        flexDirection: 'column',
        [theme.breakpoints.up('sm')]: {
            flexDirection: 'row',
        },
    },
    header: {
        ...helpers_1.responsivePadding(theme, true),
        position: 'relative',
        backgroundColor: theme.palette.background.default,
        borderRadius: 0,
        '& > *': {
            ...helpers_1.responsiveWidth(theme),
        },
        [theme.breakpoints.up('sm')]: {
            width: '40%',
            display: 'flex',
            flexDirection: 'column',
        },
    },
    footer: {
        marginTop: 'auto',
        ...helpers_1.responsivePadding(theme, true),
        backgroundColor: theme.palette.background.default,
    },
    wrapperResponsiveWidth: {
        ...helpers_1.responsiveWidth(theme),
    },
    wrapperResponsivePadding: {
        ...helpers_1.responsivePadding(theme),
    },
    wrapperMain: {
        ...helpers_1.responsivePadding(theme, true),
    },
    wrapperBottomNav: {
        ...helpers_1.responsiveWidth(theme),
        [theme.breakpoints.up('md')]: {
            ...helpers_1.responsivePadding(theme),
        },
    },
    wrapperContent: {
        minHeight: 'calc( 100vh - 220px - 37px - 64px )',
        width: '100%',
        boxSizing: 'border-box',
        ...helpers_1.responsiveWidth(theme),
        paddingBottom: theme.spacing(4),
        [theme.breakpoints.up('md')]: {
            minHeight: 'calc( 100vh - 37px - 64px )',
        },
    },
    extraContentWrapper: {
        minHeight: '73px',
    },
    showOnMobile: {
        display: 'flex',
        [theme.breakpoints.up('sm')]: {
            display: 'none',
        },
    },
    showOnTablet: {
        display: 'none',
        [theme.breakpoints.up('sm')]: {
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
        },
    },
    extraDesign: {
        display: 'none',
        [theme.breakpoints.up('md')]: {
            height: '15%',
            position: 'absolute',
            width: '75%',
            bottom: 0,
            left: 0,
            // eslint-disable-next-line max-len
            background: `radial-gradient(180% 180% at right -55% top -65%, transparent 99%, ${theme.palette.primary.main})`,
            zIndex: 5,
            display: 'block',
        },
    },
    extraDesign2: {
        display: 'none',
        [theme.breakpoints.up('md')]: {
            height: '30%',
            position: 'absolute',
            width: '75%',
            bottom: 0,
            left: 0,
            // eslint-disable-next-line max-len
            background: `radial-gradient(180% 180% at right -60% top -65%, transparent 99%, ${theme.palette.primary.light})`,
            display: 'block',
        },
    },
}));
const StepLayout = ({ progressBarProps, navigationHeaderProps, bottomNav, ExtraContent, children, }) => {
    const classes = useStyles();
    const scrollbarsRef = react_1.useRef(null);
    const height = react_div_100vh_1.use100vh();
    const theme = core_1.useTheme();
    // whenever we switch steps, scroll to the top
    react_1.useEffect(() => {
        if (scrollbarsRef.current) {
            // @ts-ignore
            scrollbarsRef.current.scrollToTop();
        }
    }, [progressBarProps.title]);
    return (react_1.default.createElement(core_1.Box, { className: classes.root, height: height, display: 'flex', bgcolor: theme.palette.background.default },
        react_1.default.createElement(core_1.Paper, { className: classes.header },
            react_1.default.createElement(NavigationHeader_1.default, { ...navigationHeaderProps }),
            react_1.default.createElement("div", { className: classes.showOnMobile },
                react_1.default.createElement(ProgressBar_1.default, { ...progressBarProps })),
            react_1.default.createElement("div", { className: classes.showOnTablet },
                react_1.default.createElement(ProgressTab_1.ProgressTab, { ...progressBarProps }),
                react_1.default.createElement(core_1.Box, { className: classes.extraContentWrapper }, ExtraContent)),
            react_1.default.createElement("div", { className: classes.extraDesign }, "\u00A0"),
            react_1.default.createElement("div", { className: classes.extraDesign2 }, "\u00A0")),
        react_1.default.createElement(react_custom_scrollbars_1.default, { ref: scrollbarsRef },
            react_1.default.createElement("div", { className: classes.wrapperMain },
                react_1.default.createElement("div", { className: classes.wrapperContent }, children),
                react_1.default.createElement("div", { className: classes.wrapperBottomNav }, bottomNav)))));
};
exports.StepLayout = StepLayout;
//# sourceMappingURL=data:application/json;base64,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